import {
  Listing,
  MenuListingsLayout,
  OrderEstimateExtraSelection,
} from '@tovala/browser-apis-combinedapi'
import { Extra, QuantityStepper } from '@tovala/component-library'
import { formatCentsToDollars } from 'utils/currency'

const ExtrasGrid = ({
  canModifySelections,
  disabledDecrement,
  disabledIncrement,
  listingsSelections,
  menuListingsLayout,
  onClickDecrement,
  onClickIncrement,
  onClickListing,
}: {
  canModifySelections: boolean
  disabledDecrement: boolean
  disabledIncrement: boolean
  listingsSelections: OrderEstimateExtraSelection[]
  menuListingsLayout: MenuListingsLayout
  onClickDecrement({
    index,
    listing,
  }: {
    index: number
    listing: Listing
  }): void
  onClickIncrement({
    index,
    listing,
  }: {
    index: number
    listing: Listing
  }): void
  onClickListing(listingID: string): void
}) => {
  if (
    !menuListingsLayout.sections ||
    menuListingsLayout.sections.length === 0
  ) {
    return null
  }

  function makeQuantityStepper({
    index,
    listing,
  }: {
    index: number
    listing: Listing
  }) {
    const quantity =
      listingsSelections.filter(
        (listingSelection) => listingSelection.listingID === listing.id,
      )?.length ?? 0

    if (!canModifySelections || (listing.isSoldOut && quantity === 0)) {
      return { quantity: 0, stepper: null }
    }

    return {
      quantity,
      stepper: (
        <QuantityStepper
          disabledDecrement={disabledDecrement}
          disabledIncrement={disabledIncrement || listing.isSoldOut}
          labelDecrement="Remove Extra"
          labelIncrement="Add Extra"
          min={0}
          onClickDecrement={() => {
            onClickDecrement({ index, listing })
          }}
          onClickIncrement={() => {
            onClickIncrement({ index, listing })
          }}
          quantity={quantity}
          size="small"
        />
      ),
    }
  }

  let flatListingIndex = 0

  return (
    <div className="mx-auto max-w-menu space-y-10 md:space-y-8">
      {menuListingsLayout.sections.map((section, index) => {
        if (section.listings.length > 0) {
          return (
            <div key={`section-${index}`} className="space-y-6 md:space-y-4">
              {section.title && (
                <h2 className="text-k/28_110 md:px-4 md:text-k/20_110">
                  {section.title}
                </h2>
              )}
              <div className="grid grid-cols-3 gap-x-4 gap-y-8 md:grid-cols-2 md:gap-x-3 md:px-4">
                {section.listings.map((listing) => {
                  const listingIndex = flatListingIndex++
                  return (
                    <div key={listing.id} data-testid={`listing-${listing.id}`}>
                      <Extra
                        badgeText={listing.badgeText}
                        imageURL={listing.imageURL}
                        isSoldOut={listing.isSoldOut}
                        onClickListing={() => {
                          onClickListing(listing.id)
                        }}
                        price={formatCentsToDollars(listing.priceCents)}
                        stepper={
                          makeQuantityStepper({
                            index: listingIndex,
                            listing,
                          }).stepper
                        }
                        title={listing.title}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}

export default ExtrasGrid
